import { hostedApiActivity } from "./repos/hosted/hostedApiActivity";
import { hostedApiAppointable } from "./repos/hosted/hostedApiAppointable";
import { hostedApiClub } from "./repos/hosted/hostedApiClub";
import { hostedApiCreditPack } from "./repos/hosted/hostedApiCreditPack";
import { hostedApiEventOccurrence } from "./repos/hosted/hostedApiEventOccurrence";
import { hostedApiFacility } from "./repos/hosted/hostedApiFacility";
import { hostedApiLead } from "./repos/hosted/hostedApiLead";
import { hostedApiMember } from "./repos/hosted/hostedApiMember";
import { hostedApiMembership } from "./repos/hosted/hostedApiMembership";
import { hostedApiProduct } from "./repos/hosted/hostedApiProduct";
import { hostedApiRules } from "./repos/hosted/hostedApiRules";
import { memberApiAccess } from "./repos/member/memberApiAccess";
import { memberApiActivity } from "./repos/member/memberApiActivity";
import { memberApiAppointable } from "./repos/member/memberApiAppointable";
import { memberApiAppointment } from "./repos/member/memberApiAppointment";
import { memberApiAvailability } from "./repos/member/memberApiAvailability";
import { memberApiCreditPack } from "./repos/member/memberApiCreditPack";
import { memberApiEventOccurrence } from "./repos/member/memberApiEventOccurrence";
import { memberApiFacility } from "./repos/member/memberApiFacility";
import { memberApiMember } from "./repos/member/memberApiMember";
import { memberApiMembership } from "./repos/member/memberApiMembership";
import { memberApiOnboarding } from "./repos/member/memberApiOnboarding";
import { memberApiProduct } from "./repos/member/memberApiProduct";
import { memberApiSubscription } from "./repos/member/memberApiSubscription";
import { memberApiVoucher } from "./repos/member/memberApiVoucher";
import { memberApiWallet } from "./repos/member/memberApiWallet";
import { staffApiActivity } from "./repos/staff/staffApiActivity";
import { staffApiAppSettings } from "./repos/staff/staffApiAppSettings";
import { staffApiEventOccurrence } from "./repos/staff/staffApiEventOccurrence";
import { staffApiFacility } from "./repos/staff/staffApiFacility";
import { staffApiHost } from "./repos/staff/staffApiHost";
import { staffApiLead } from "./repos/staff/staffApiLead";
import { staffApiMember } from "./repos/staff/staffApiMember";
import { staffApiSms } from "./repos/staff/staffApiSms";
import { staffApiSubscription } from "./repos/staff/staffApiSubscription";
import { staffApiVoucher } from "./repos/staff/staffApiVoucher";
import { staffApiWallet } from "./repos/staff/staffApiWallet";

export const apiV2 = {
  hosted: {
    creditPack: hostedApiCreditPack,
    membership: hostedApiMembership,
    product: hostedApiProduct,
    appointable: hostedApiAppointable,
    activity: hostedApiActivity,
    rules: hostedApiRules,
    eventOccurrence: hostedApiEventOccurrence,
    facility: hostedApiFacility,
    member: hostedApiMember,
    lead: hostedApiLead,
    club: hostedApiClub,
  },
  member: {
    member: memberApiMember,
    membership: memberApiMembership,
    subscription: memberApiSubscription,
    creditPack: memberApiCreditPack,
    product: memberApiProduct,
    appointable: memberApiAppointable,
    appointment: memberApiAppointment,
    activity: memberApiActivity,
    availability: memberApiAvailability,
    eventOccurrence: memberApiEventOccurrence,
    facility: memberApiFacility,
    onboarding: memberApiOnboarding,
    access: memberApiAccess,
    voucher: memberApiVoucher,
    wallet: memberApiWallet,
  },
  staff: {
    activity: staffApiActivity,
    host: staffApiHost,
    facility: staffApiFacility,
    lead: staffApiLead,
    member: staffApiMember,
    sms: staffApiSms,
    voucher: staffApiVoucher,
    appSettings: staffApiAppSettings,
    eventOccurrence: staffApiEventOccurrence,
    subscription: staffApiSubscription,
    wallet: staffApiWallet,
  },
} as const;
